exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.international-icon[data-v-8ec1b724] {\n  font-size: 20px;\n  cursor: pointer;\n  vertical-align: -5px !important;\n}\n", ""]);

// exports
